import _keyBy from 'lodash/keyBy';
import _mapValues from 'lodash/mapValues';
import { Dispatch } from 'redux';
import { Entity, Field, generateMutation, generateQuery, MutationType, QueryType } from 'typegraph';

import ActionTypes from 'core/actions/actionTypes';
import { beginAjaxCall } from 'core/actions/ajaxStatusActions';
import EditorToaster from 'core/components/editor/EditorToaster';
import { IDictionaryEntry } from 'core/components/label/ILabel';
import initialState from 'core/reducers/initialState';
import IResolverService from 'core/service/resolver/IResolverService';
import Logger from 'core/util/Logger';
import { actionResultFrom } from 'core/util/MutationUtil';
import ServiceRegistry from 'core/util/ServiceRegistry';


@Entity({
	many: "dictionaryEntry_many",
	create: "dictionaryEntry_one_create",
	delete: "dictionaryEntry_one_delete"
})
class DictionaryEntry {
	@Field() public id: any;
	@Field() public key: string;
	@Field() public language: string;
	@Field() public instance: string;
	@Field() public value: string;
	@Field() public type: string;
}

// Action Creators
export function loadDictionarySuccess(dictionary) {
	return { type: ActionTypes.DICTIONARY_LOAD_SUCCESS, dictionary };
}

export function dictionaryAddEntries(entries: IDictionaryEntry[]) {
	return { type: ActionTypes.DICTIONARY_ENTRIES_ADD, entries };
}

export function dictionaryAddEntry(entry: IDictionaryEntry) {
	return { type: ActionTypes.DICTIONARY_ENTRY_ADD, entry };
}

export function dictionaryRemoveEntry(entry: IDictionaryEntry) {
	return { type: ActionTypes.DICTIONARY_ENTRY_REMOVE, entry };
}

export function dictionaryLoadEntries(language: string) {
	return (dispatch: Dispatch<typeof initialState>) => {
		dispatch(beginAjaxCall());

		const resolver = ServiceRegistry.get(IResolverService);


		const params = { language };

		return resolver.execute(generateQuery(DictionaryEntry, QueryType.MANY, { params }, "entries")).then((res) => {
			if (res && res.data && res.data.entries) {
				dispatch(dictionaryAddEntries(res.data.entries));
			}
		}).catch((err) => Logger.error(err));
	};
}

export function dictionarySaveEntry(entry: IDictionaryEntry) {
	return (dispatch: Dispatch<typeof initialState>) => {
		// optimistic update?
		dispatch(dictionaryAddEntry(entry));

		const resolver = ServiceRegistry.get(IResolverService);

		const params = {
			key: entry.key,
			language: entry.language,
			instance: entry.instance || null,
			value: entry.value,
			type: entry.type || null
		};

		return resolver.execute(generateMutation(DictionaryEntry, MutationType.CREATE, {params})).then((res) => {
			EditorToaster.show({message: "Saved Dictionary Entry"});
		}).catch((err) => Logger.error(err));
	};
}

export function dictionaryDeleteEntry(entry: { key: string; language: string; instance?: string; }) {
	return (dispatch: Dispatch<typeof initialState>) => {
		dispatch(dictionaryRemoveEntry(entry));

		const resolver = ServiceRegistry.get(IResolverService);

		const params = {
			key: entry.key,
			language: entry.language,
			instance: entry.instance || null
		};

		return resolver.execute(generateMutation(DictionaryEntry, MutationType.DELETE, { params })).then((res) => {
			EditorToaster.show({message: "Deleted Dictionary Entry"});
		}).catch((err) => Logger.error(err));
	};
}



// WEBPACK FOOTER //
// ./src/core/actions/dictionaryActions.ts